
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import SEO from 'global/SEO';
import { siteUrl } from 'constants/app';
import dynamic from 'next/dynamic';

const Seasonality = dynamic(() => import('features/pro-tools/Seasonality'));
const HomePageLayout = dynamic(() => import('global/HomePageLayout'));

function SeasonalityPage() {
  return (
    <HomePageLayout whiteFooterBackground>
      <SEO
        title="Stockbit - Seasonality Tools"
        description="Prediksi dan manfaatkan momentum tren harga saham berdasarkan waktu ke waktu. Lebih dari 15 tahun price history dan analisa probabilitas kenaikan harga."
        url={`${siteUrl}/info/pro-tools/seasonality`}
      />
      <Seasonality />
    </HomePageLayout>
  );
}

export default SeasonalityPage;
